import { lazyLoad } from 'utils/loadable';

export const DepartmentListPage = lazyLoad(
  () => import('./index'),
  module => module.DepartmentListPage,
);
